module.exports = __webpack_public_path__ + "static/img/4.5029107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/4.jpg
// module id = dmny
// module chunks = 0